import VRMConfirmationModal from '@components/auto-account-creation/VRMConfirmationModal/VRMConfirmationModal';
import { useAppSelector } from '@redux/hooks';
import { FullscreenModal, TextBody, TextHero } from '@tkww/orion-web-ds';
import React from 'react';
import VendorRecommendationModule from '../../../lib/vendor-recommendation-module/VRM';
import { TooltipInfo } from './components/TooltipInfo';
import { VendorNetwork } from './components/VendorNetwork';
import { VenueCard } from './components/VenueCard';
import { useVendorNetworkData } from './hooks/useVendorNetworkData';
import Styles from './styles.scss';

interface VendorNetworkModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const VendorNetworkModal: React.FC<VendorNetworkModalProps> = ({
	isOpen,
	onClose,
}) => {
	const isMobile = useAppSelector((state) => state.viewport.isMobile);
	const {
		member,
		vendorRaw,
		selectedCategoryCode,
		showVrmConfirmation,
		contactedVendors,
		allContactedIds,
		recommendedVendors,
		vrmTitle,
		vrmTextArea,
		handleCategoryClick,
		handleVrmClose,
		handleVrmSubmit,
		handleVrmConfirmationClose,
	} = useVendorNetworkData(isMobile);

	if (!vendorRaw || !member) return null;

	return (
		<>
			<FullscreenModal
				isOpen={isOpen && !selectedCategoryCode}
				onClose={onClose}
				showLogo={false}
			>
				<div className={`${Styles.container} vendor-network-modal-container`}>
					<div className={Styles.headingSection}>
						<div className={Styles.headingWrapper}>
							<TextHero size="sm" className={Styles.title}>
								Meet pros who know your venue
							</TextHero>
							<div className={Styles.subtitleWrapper}>
								<TextBody className={Styles.subtitle}>
									Reach out to vendors who may have worked with your venue to
									make planning easier.
									<TooltipInfo />
								</TextBody>
							</div>
						</div>
						<VenueCard />
					</div>
					<div className={Styles.contentWrapper}>
						<VendorNetwork
							onCategoryClick={handleCategoryClick}
							contactedIds={allContactedIds}
						/>
					</div>
				</div>
			</FullscreenModal>

			{showVrmConfirmation && (
				<VRMConfirmationModal
					isModalOpen={showVrmConfirmation}
					closeCallback={handleVrmConfirmationClose}
					onNextButtonClick={handleVrmConfirmationClose}
					contactedVendors={contactedVendors}
					indirectLeadsCount={contactedVendors.length}
					sourcePage="paid storefront"
					hideActionButton
				/>
			)}

			{selectedCategoryCode &&
				recommendedVendors.length > 0 &&
				!showVrmConfirmation && (
					<VendorRecommendationModule
						key={selectedCategoryCode}
						buttonType="vendor-network"
						initiator="vendor-network"
						isOpen={true}
						member={member}
						onClose={handleVrmClose}
						onSubmit={handleVrmSubmit}
						pageType="paid storefront"
						recommendations={recommendedVendors}
						referred={null}
						vendorRaw={vendorRaw}
						titleOverride={vrmTitle}
						messageOverride={vrmTextArea}
						hideSubtitle={true}
						hideTopBadges={true}
					/>
				)}
		</>
	);
};
